/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2024 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import { undo as a, redo as c } from "@progress/kendo-editor-common";
import { createProseMirrorTool as e } from "./proseMirrorTool.mjs";
var t;
((r) => {
  r.createUndoTool = (o) => e(o, a), r.createRedoTool = (o) => e(o, c);
})(t || (t = {}));
export {
  t as HistoryToolNS
};
